import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FilterListIcon from 'mdi-react/FilterListIcon';

class MatTableFilterButton extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
  };

  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSort = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
    this.handleClose();
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <IconButton
          className="material-table__toolbar-button"
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <FilterListIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          className="material-table__filter-menu"
        >
          <MenuItem 
            onClick={this.handleSort('type')} 
            className="material-table__filter-menu-item"
          >
              Type
          </MenuItem>
          <MenuItem 
            onClick={this.handleSort('windowscount')} 
            className="material-table__filter-menu-item"
          >
              nb. de commerces
          </MenuItem>
          <MenuItem 
            onClick={this.handleSort('product')} 
            className="material-table__filter-menu-item"
          >
              Décor
          </MenuItem>
          <MenuItem 
            onClick={this.handleSort('amount')} 
            className="material-table__filter-menu-item"
          >
            Montant
          </MenuItem>
          <MenuItem
            onClick={this.handleSort('datefrom')}
            className="material-table__filter-menu-item"
          >
            Date de début
          </MenuItem>
          <MenuItem
            onClick={this.handleSort('dateto')}
            className="material-table__filter-menu-item"
          >
            Date de fin
          </MenuItem>
          <MenuItem
            onClick={this.handleSort('datecreate')}
            className="material-table__filter-menu-item"
          >
            Date de la simulation
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default MatTableFilterButton;
